"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var SettingsTabContent = /** @class */ (function (_super) {
    __extends(SettingsTabContent, _super);
    function SettingsTabContent(props) {
        return _super.call(this, props) || this;
    }
    SettingsTabContent.prototype.render = function () {
        return (React.createElement(reactstrap_1.TabPane, { tabId: this.props.tabId },
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { sm: "12" }, this.props.children))));
    };
    return SettingsTabContent;
}(React.Component));
exports.SettingsTabContent = SettingsTabContent;
//# sourceMappingURL=SettingsTabContent.js.map